// extracted by css-extract-rspack-plugin
export default {"rowCategoryArrow":"CategoryContainer_rowCategoryArrow__TVrZV","spanId":"CategoryContainer_spanId__9HsJQ"};